import { CreateChartOptionsWithColors } from '@chart/types/create.types';

export const clearChart = (
  context: CanvasRenderingContext2D,
  options: CreateChartOptionsWithColors
) => {
  return context.clearRect(0, 0, options.width, options.height);
};
